import { render, staticRenderFns } from "./SelectPaytype.vue?vue&type=template&id=2580b7f8&scoped=true&"
import script from "./SelectPaytype.vue?vue&type=script&lang=js&"
export * from "./SelectPaytype.vue?vue&type=script&lang=js&"
import style0 from "./SelectPaytype.vue?vue&type=style&index=0&id=2580b7f8&prod&lang=scss&"
import style1 from "./SelectPaytype.vue?vue&type=style&index=1&id=2580b7f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2580b7f8",
  null
  
)

export default component.exports